/**
 * @exports default
 */
export default {
  ADOBE_ACCOUNT_BASE: 'schibstedspainmotor',
  ADOBE_ACCOUNT_ENV: 'dev',
  ENVIRONMENT: 'development',
  API_SUBDOMAIN: 'web.',
  API_DOMAIN: 'pregw.coches.net',
  API_GW_DOMAIN: 'pregw.coches.net',
  API_GW_SUBDOMAIN_CNET_CONTENT: 'cnet-content.',
  API_GW_SUBDOMAIN_SUBSCRIPTION: 'subscription.',
  API_INTERNAL_URL: 'http://ms-mt--api-gateway-web.mt-pre.motor-internal.com',
  SESSION_STARTER_URL: 'session-starter.',
  CONTENTFUL_API_URL: 'https://content.pregw.coches.net',
  ADVERTISING_ENV: 'dev',
  RE_CAPTCHA_KEY: '6LdmxaoUAAAAAHwR99KeSLOrJxWIgZETMvQ3TT-s',
  ADYEN_SCRIPT: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/3.1.0/adyen.js',
  ADYEN_STYLES: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/3.1.0/adyen.css',
  CALL_ME_NOW_CAMPAIGN_CODE: 'XR9B',
  SAITAMA_CONFIG_URL: 'https://adit.gw.coches.net/saitama/v1',
  SECURE_COOKIES: false,
  MESSAGING_WIDGET_ENV: 'pre',
  TRUST_FEEDBACK_API_URL: 'https://feedback-api.trust-pre.mpi-internal.com',
  SEO_CONTENT_API_URL: 'https://seo-content.pregw.coches.net'
}
